module.exports = __webpack_public_path__ + "img/GasbotIcon.98d8ac67.svg";